var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.collapsed
    ? _c("div", { staticClass: "footer__collapsed" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/icons/new-ui/left-navbar/expand-arrow.svg"),
            width: "13px",
          },
          on: { click: _vm.notifyExpand },
        }),
      ])
    : _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "version" }, [
          _vm._v("\n    v. " + _vm._s(_vm.vars.COMMIT) + "\n  "),
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/assets/icons/new-ui/left-navbar/collapse-arrow.svg"),
            width: "13px",
          },
          on: { click: _vm.notifyCollapse },
        }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }